export default {"src":"/_next/static/media/image_PowerBI.1ed9eedf.svg","height":177,"width":306,"blurWidth":0,"blurHeight":0};